import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const MobileStyles = css`
  min-height: 78px;
  margin-bottom: 9px;
  border-radius: 0;
  border-right: 0;
  border-left: 0;
`;

export const AlertWrapper = styled.div`
  min-height: 49px;
  border-width: 1px;
  border-style: solid;
  padding: 5px 20px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 30px;
  background-color: #e6f7ff;
  border-color: #9ed5ff;

  @media only screen and (max-width: 767px) {
    ${MobileStyles}
  }
  p {
    margin-bottom: 0;
    margin-left: 13px;
    color: ${themeGet('text.0', '#2c2c2c')};
    font-size: 15px;
  }
`;

export const AlertInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const TimerWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 74px;
  padding: 16px 35px 13px 16px;
  border-radius: 2px;
  border: solid 1px #fbd1a2;
  background-color: #fff6ed;
  margin-bottom: 22px;
  line-height: 1.29;
  color: black;

  img {
    max-height: 34px;
    max-width: 39px;
  }

  &.with-payment {
    margin-bottom: 30px;
  }

  &.expired {
    background-color: #e6f7ff;
    border-color: #9ed5ff;
  }
`;

export const TimerDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 40px;
  margin-left: 16px;

  .timer-subtitle {
    font-size: 14px;
    font-weight: normal;
  }

  @media only screen and (max-width: 767px) {
    margin-left: 0;
    .timer-subtitle {
      color: #494949;
      font-size: 15px;
      line-height: 19px;
      padding-bottom: 9px;
    }
  }
`;

export const Timer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TimeLeft = styled.div`
  .timer-title {
    font-size: 16px;
    font-weight: bold;
  }

  .timer-clock {
    font-size: 20px;
    font-weight: bold;
  }

  @media only screen and (max-width: 767px) {
    .timer-title,
    .timer-clock {
      color: #494949;
    }
  }
`;

export const CollapseWrapper = styled.div`
  margin-bottom: 9px;
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    .ant-collapse-arrow {
      right: 24px;
      top: 22px;
      svg {
        stroke: #545556;
        stroke-width: 80px;
      }
    }
  }
  .ant-collapse.expired > .ant-collapse-item > .ant-collapse-header {
    .ant-collapse-arrow {
      top: 17px;
    }
  }
  .ant-collapse {
    > .ant-collapse-item {
      border-top: 1px solid #ffca9c;
      border-bottom: 1px solid #ffca9c;
    }
    &.expired {
      > .ant-collapse-item {
        border-top: 1px solid #9ed5ff;
        border-bottom: 1px solid #9ed5ff;
      }
    }
  }
  .ant-collapse.ant-collapse-borderless {
    background-color: #fff3e8;
  }

  .ant-collapse.expired.ant-collapse-borderless {
    background-color: #e6f7ff;
  }

  .ant-collapse.ant-collapse-borderless > .ant-collapse-item {
    .ant-collapse-header {
      padding-top: 21px;
      padding-bottom: 18px;
      padding-left: 18px;
    }
    .ant-collapse-content > .ant-collapse-content-box {
      padding-top: 0;
      padding-left: 18px;
      padding-right: 18px;
    }
  }

  .ant-collapse.expired.ant-collapse-borderless > .ant-collapse-item {
    .ant-collapse-content > .ant-collapse-content-box {
      padding-left: 24px;
    }
  }
`;

export const CollapseHeader = styled.div`
  display: flex;
  align-items: center;
  .timer-title {
    margin-left: 16px;
  }
  &.expired {
    .timer-title {
      margin-left: 6px;
    }
  }
`;
